/**
 * Product feature flags — single source of truth.
 * Re-enable billing/plans UI by flipping PLANS_ENABLED to true (no scattered booleans).
 */
export const PLANS_ENABLED = false;

/** True when plan/pricing/billing UI and routes should be shown. */
export function plansEnabled(): boolean {
  return PLANS_ENABLED;
}

/**
 * Future plan-limit checks (job caps, unlock caps, etc.) should call this.
 * While plans are disabled, every employer is treated as unlimited.
 * When PLANS_ENABLED is true, return false so callers apply real tier limits.
 */
export function employerHasUnlimitedAccess(): boolean {
  return !PLANS_ENABLED;
}
